import React, { Fragment, useEffect, useRef, useState } from "react";

import { useFormikContext } from "formik";
import { useCoursesContext } from "./../layout/courses/CourseProvider";

import { toast, ToastContainer } from "react-toastify";

const Hole = () => {
  const holeTimeRef = useRef();

  const executeScroll = () =>
    holeTimeRef.current.scrollIntoView({ behavior: "smooth" });

  const formik = useFormikContext();
  const { data, activeCourseIndex, clicking } = formik.values;
  const courseData = data[activeCourseIndex];
  const [holes, setHoles] = useState([]);
  const [keyCode, setKeyCode] = useState();

  const { onSubmit } = useCoursesContext();



  useEffect(() => {
    if (courseData) {
      setHoles([...courseData?.hole_details]);
    }
  }, [courseData]);

  useEffect(() => {
    executeScroll();
  }, [activeCourseIndex, clicking]);

  const handleCourseDetails = () => {
    console.log(data[activeCourseIndex]);
    console.log(holes);
    onSubmit(formik);
  };

  const onChangeAllocated = (input, id, keyValue) => {
    if (input.target.value.length < 6) {
      const updatedList = holes.map((hole) => {
        if (id == hole.id) {
          if (keyCode === 8) {
            hole[keyValue] = input.target.value;
          } else if (keyCode === 186) {
            console.log("jk");
          } else if (input.target.value.match(/^[0-9, :]+$/)) {
            if (input.target.value.length === 2) {
              hole[keyValue] = `${input.target.value}:`;
            } else {
              hole[keyValue] = input.target.value;
            }
          }

          return hole;
        } else {
          return hole;
        }
      });
      setHoles(updatedList);
    }
  };

  const applyToAll = (value, keyValue) => {
    const updatedList = holes.map((hole) => {
      hole[keyValue] = value;
      return hole;
    });
    setHoles(updatedList);
  };

  return (
    <>
      <ToastContainer />
      <div ref={holeTimeRef} className="c-mapping__box">
        <h2 className="c-mapping__box-txt text-jost-sb-24">
          Hole times for {courseData?.course_name}
        </h2>
        <p className="c-mapping__box-para text-ops-rg-16">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean porta,
          felis vitae accumsan semper, urna velit consequat nibh.
        </p>
        <div className="hole">
          <table className="hole__table">
            <tr className="hole__table_head">
              <th className="text-jost-sb-18"></th>
              <th className="text-jost-sb-18">Time allocated to hole</th>
              <th className="text-jost-sb-18">Amber alert after</th>
              <th className="text-jost-sb-18">Red alert after</th>

              <th className="text-jost-sb-18">Time To Start next hole</th>
            </tr>
            {holes.map((hole, index) => (
              <Fragment>
                <tr id="row1" className="hole__table_content">
                  <td id="cell1-0" className="text-jost-sb-18">
                    Hole {hole.hole_index}
                  </td>
                  <td id="cell1-1">
                    {" "}
                    <input
                      onKeyDown={(e) => setKeyCode(e.keyCode)}
                      className="form__input-sm"
                      type="text"
                      placeholder="mm:ss"
                      name=""
                      value={hole.allocated_to_hole || ""}
                      onChange={(i) => {
                        onChangeAllocated(i, hole.id, "allocated_to_hole");
                      }}
                      required
                    />
                  </td>
                  <td id="cell1-1">
                    {" "}
                    <input
                      onKeyDown={(e) => setKeyCode(e.keyCode)}
                      className="form__input-sm"
                      type="text"
                      placeholder="mm:ss"
                      name=""
                      value={hole.amber_alert_after || ""}
                      onChange={(i) => {
                        onChangeAllocated(i, hole.id, "amber_alert_after");
                      }}
                      required
                    />
                  </td>
                  <td id="cell1-1">
                    {" "}
                    <input
                      onKeyDown={(e) => setKeyCode(e.keyCode)}
                      className="form__input-sm"
                      type="text"
                      placeholder="mm:ss"
                      name=""
                      value={hole.red_alert_after || ""}
                      onChange={(i) => {
                        onChangeAllocated(i, hole.id, "red_alert_after");
                      }}
                      required
                    />
                  </td>
                  <td id="cell1-1">
                    {" "}
                    <input
                      onKeyDown={(e) => setKeyCode(e.keyCode)}
                      className="form__input-sm"
                      type="text"
                      placeholder="mm:ss"
                      name=""
                      value={hole.to_start_next_hole || ""}
                      onChange={(i) => {
                        onChangeAllocated(i, hole.id, "to_start_next_hole");
                      }}
                      required
                    />
                  </td>
                </tr>
                {index == 0 && (
                  <tr id="row1" className="hole__table_content">
                    <td id="cell1-0" className="text-jost-sb-18"></td>
                    <td id="cell1-1">
                      {" "}
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          applyToAll(
                            hole.allocated_to_hole,
                            "allocated_to_hole"
                          );
                        }}
                        className="acccore__box__sec2-link"
                      >
                        Apply To All
                      </a>
                    </td>
                    <td id="cell1-1">
                      {" "}
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          applyToAll(
                            hole.amber_alert_after,
                            "amber_alert_after"
                          );
                        }}
                        className="acccore__box__sec2-link"
                      >
                        Apply To All
                      </a>
                    </td>
                    <td id="cell1-1">
                      {" "}
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          applyToAll(hole.red_alert_after, "red_alert_after");
                        }}
                        className="acccore__box__sec2-link"
                      >
                        Apply To All
                      </a>
                    </td>
                    <td id="cell1-1">
                      {" "}
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          applyToAll(
                            hole.to_start_next_hole,
                            "to_start_next_hole"
                          );
                        }}
                        className="acccore__box__sec2-link"
                      >
                        Apply To All
                      </a>
                    </td>
                  </tr>
                )}
              </Fragment>
            ))}
          </table>
          <a
            style={{ marginTop: "3rem" }}
            onClick={handleCourseDetails}
            target="_self"
            className="res-btn-primary c-mapping__box-next"
          >
            Save Course
          </a>
        </div>
      </div>
    </>
  );
};
export default Hole;
